import { render, staticRenderFns } from "./BlacklistOperationForm.vue?vue&type=template&id=5512d309&scoped=true&"
import script from "./BlacklistOperationForm.vue?vue&type=script&lang=js&"
export * from "./BlacklistOperationForm.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistOperationForm.vue?vue&type=style&index=0&id=5512d309&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5512d309",
  null
  
)

export default component.exports